import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer } from '../../styled/layout.styled';

const StyledLabel = styled.label`
  opacity: 0.6;
  color: #f8f5ff;
  padding-bottom: 4px;
`;
const StyledInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  padding: 14px 0 14px 16px;
  border: ${({ border }) => border || 'solid 1px rgba(199, 186, 241, 0.2)'};
  background-color: ${({ backGroundColor }) => backGroundColor || '#0d0428'};
  color: ${({ theme, opacity }) => (opacity ? 'rgba(255,255,255, 0.5)' : theme.color.white)};
  &:focus {
    ${({ modalInputActive }) => modalInputActive
    ? css`
            border: 1px solid #c7baf1;
            background-color: #0d0428;
          `
    : css`
            border: 1px solid #c7baf1;
            background-color: #12033d;
            outline: #c7baf1;
          `}
  }
  transition: all 0.3s ease;
`;

const StyledSpan = styled.span`
  margin: 0;
  color: ${({ theme }) => theme.color.error};
  padding-top: 2px;
`;

const Input = React.forwardRef(
  (
    {
      label,
      error,
      inputType,
      name,
      value,
      backGroundColor,
      readOnly,
      disabled,
      border,
      modalInputActive,
      opacity,
      serverError,
      accountSettings,
    },
    ref
  ) => (
    <>
      {accountSettings ? (
        <FlexContainer flexDirection="column" width="100%">
          <StyledLabel className="small">{label}</StyledLabel>
          <StyledInput
            className="small"
            readOnly={readOnly}
            backGroundColor={backGroundColor}
            type={inputType}
            name={name}
            defaultValue={value}
            ref={ref}
            disabled={disabled}
            border={border}
            modalInputActive={modalInputActive}
            opacity={opacity}
          />
        </FlexContainer>
      ) : (
        <FlexContainer flexDirection="column" width="100%">
          <StyledLabel className="small">{label}</StyledLabel>
          <StyledInput
            className="small"
            readOnly={readOnly}
            backGroundColor={backGroundColor}
            type={inputType}
            name={name}
            defaultValue={value}
            ref={ref}
            disabled={disabled}
            border={error[name] || serverError ? 'solid 1px #ff2976' : 'solid 1px rgba(199, 186, 241, 0.2)'}
            modalInputActive={modalInputActive}
            opacity={opacity}
          />
          {error[name] || serverError ? (
            <StyledSpan className="xsmall">{(error[name] && error[name].message) || serverError}</StyledSpan>
          ) : null}
        </FlexContainer>
      )}
    </>
  )
);

Input.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  error: PropTypes.object,
  backGroundColor: PropTypes.string,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  border: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  modalInputActive: PropTypes.bool,
  opacity: PropTypes.number,
  serverError: PropTypes.string,
  accountSettings: PropTypes.bool,
};

Input.defaultProps = {
  value: undefined,
  backGroundColor: '',
  error: {},
  readOnly: false,
  disabled: false,
  border: false,
  modalInputActive: false,
  opacity: 0,
  serverError: '',
  accountSettings: false,
};

export default Input;
